/**
 * DashboardWalkthrough — DEPRECATED in iter186.
 *
 * The 4-step onboarding row inside TodayTab.js now surfaces the same
 *   Add Subject → Record A Lecture → Generate Notes → Learn
 * flow inline above the dashboard tabs, so this bottom-right coach-mark
 * card became redundant and was visually overlapping the new row on
 * first login. We render nothing and proactively set the legacy
 * `isp_walkthrough_v2_done` flag so no one ever sees it again.
 *
 * The file is intentionally left in place (rather than deleted) so the
 * existing import in /pages/Dashboard.js keeps working without an edit
 * to that file. Safe to delete this file + the Dashboard import in a
 * follow-up cleanup.
 */
import { useEffect } from 'react';

const FLAG_KEY = 'isp_walkthrough_v2_done';

const DashboardWalkthrough = () => {
  useEffect(() => {
    try { localStorage.setItem(FLAG_KEY, '1'); } catch {/* localStorage unavailable */}
  }, []);
  return null;
};

export default DashboardWalkthrough;
